// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:23
import { CStampShareComponent_abstract } from './../abstract/SagaSchema/CStampShareComponent_abstract';
export class CStampShareComponent extends CStampShareComponent_abstract {}
